export const initialDialog = {
    open: false,
    component: null
};
//# sourceMappingURL=types.js.map